import { render, staticRenderFns } from "./FormDate.vue?vue&type=template&id=4b3adf1b&"
import script from "./FormDate.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormDate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports